import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DepreciacionAnualFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='% DEPREC. ANUAL' htmlFor='input-depreciacionAnual' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='depreciacionAnual'>
          {({ field }) => (
            <Form.InputNumber {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} min={0} max={100} id='input-depreciacionAnual' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DepreciacionAnualFormGroup)
